export default __webpack_public_path__ + "static/media/section14.e4b098c2.png";